import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ChevronDownIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path
      fillRule="evenodd"
      d="m3.646 6.354.708-.708L8 9.293l3.646-3.647.708.708L8 10.707 3.646 6.354Z"
    />
  </IconWrapper>
)

export default ChevronDownIconSmall
